import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Title } from '@omnilert/components'

import useStyles from './rounded-button.style'

const RoundedButton = (props) => {
  const {
    className,
    color,
    id,
    isLoading,
    onClick,
    text
  } = props
  const classes = useStyles(props)

  const getClasses = useMemo(() => {
    const buttonClasses = [classes.roundedButton]

    if (isLoading) buttonClasses.push(classes.isLoading)

    return classNames(buttonClasses)
  },
  [
    classes.roundedButton,
    classes.isLoading,
    isLoading
  ])

  return (
    <div
      className={classNames([classes.baseButtonContainer, { [className]: !!className }])}
      disabled={isLoading}
      id={id}
      onClick={onClick}
      role='button'
      tabIndex={0}
      type='button'
    >
      <div className={getClasses}>
        {!isLoading &&
          <Title
            className={classes.title}
            color={color}
            size='xs'
          >{text}
          </Title>}
      </div>
      <div className={classes.outterBorder} />
    </div>
  )
}

RoundedButton.defaultProps = {
  className: '',
  color: '',
  disabled: false,
  text: '',
  onClick: () => { },
  id: '',
  backgroundColor: ''
}

RoundedButton.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  backgroundColor: PropTypes.string
}

export default RoundedButton
